<template>
  <transition-group
    :name="transitionName"
    tag="div"
    class="notificaciones"
    :class="position"
    :style="containerStyle"
    >
    <div
      v-for="(noti, index) in notifications"
      :key="noti.id"
      class="notificacion"
      :class="[noti.tipo, bordePorPosicion, marcaPosicion]"
      :style="noti.style"
    >
      <div class="notificacion-contenido">
        <span class="notificacion-mensaje">{{ noti.msg }}</span>
        <button class="notificacion-cerrar" @click="cerrar(index)">×</button>
      </div>
    </div>
  </transition-group>
</template>

<script>
export default {
  name: "Notificaciones",
  props: {
    position: {
      type: String,
      default: "top-right"
    }
  },
  data() {
    return {
      notifications: [],
      containerStyle: {},
    };
  },
  computed: {
    posicionClass() {
      return this.position;
    },
    transitionName() {
      if (this.position.startsWith("top")) {
        return "fade-top";
      } else if (this.position.startsWith("bottom")) {
        return "fade-bottom";
      }
      return "fade";
    },
    bordePorPosicion() {
      switch (this.position) {
        case "top-left":
        case "bottom-left":
          return "borde-right";
        case "top-right":
        case "bottom-right":
          return "borde-left";
        case "top-center":
          return "borde-bottom";
        case "bottom-center":
          return "borde-top";
        default:
          return "";
      }
    },
    marcaPosicion() {
      switch (this.position) {
        case "top-left":
        case "bottom-left":
          return "marca-izquierda";
        case "top-right":
        case "bottom-right":
          return "marca-derecha";
        case "top-center":
          return "marca-arriba";
        case "bottom-center":
          return "marca-abajo";
        default:
          return "marca-izquierda";
      }
    }
  },
  methods: {
    
    setContainerStyle(style) {
        this.containerStyle = style;
    },
    mostrar(msg, tipo, duracion, style, containerStyle = {}) {
        const id = `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
        this.notifications.push({
            id,
            msg,
            tipo,
            style
        });
            this.setContainerStyle(containerStyle);

            setTimeout(() => {
                this.notifications = this.notifications.filter(n => n.id !== id);
            }, duracion);
    },
    cerrar(index) {
      this.notifications.splice(index, 1);
    }
  }
};
</script>

<style scoped>
.notificaciones {
  position: fixed;
  z-index: 9999;
  display: flex;
  flex-direction: column;
}

.top-right { top: 90px; right: 20px; align-items: flex-end; }
.top-left { top: 90px; left: 20px; align-items: flex-start; }
.top-center { top: 20px; left: 50%; transform: translateX(-50%); align-items: center; }
.bottom-right { bottom: 20px; right: 20px; align-items: flex-end; }
.bottom-left { bottom: 20px; left: 20px; align-items: flex-start; }
.bottom-center { bottom: 20px; left: 50%; transform: translateX(-50%); align-items: center; }

.notificacion {
  background: #f0f0f0;
  padding: 10px 20px;
  margin-bottom: 10px;
  border-radius: 4px;
  min-width: 100px;
  width: 100%;
  max-width: 240px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  word-wrap: break-word;
  white-space: normal;
}

.notificacion-contenido {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 5px;
  font-size: 14px;
}

.notificacion-mensaje {
  flex: 1;
  line-height: 1.3;
}

.notificacion-cerrar {
  background: transparent;
  border: none;
  font-size: 16px;
  cursor: pointer;
  flex-shrink: 0;
}

/* Bordes dinámicos */
.borde-left { border-radius: 16px 4px 4px 16px; }
.borde-right { border-radius: 4px 16px 16px 4px; }
.borde-top { border-radius: 16px 16px 0 0; }
.borde-bottom { border-radius: 0 0 16px 16px; }

/* Marcas */
.marca-izquierda { border-left: 5px solid; }
.marca-derecha { border-right: 5px solid; }
.marca-arriba { border-top: 5px solid; }
.marca-abajo { border-bottom: 5px solid; }

/* Colores por tipo */
.notificacion.success.marca-izquierda { border-left-color: #3c763d; }
.notificacion.success.marca-derecha { border-right-color: #3c763d; }
.notificacion.success.marca-arriba { border-top-color: #3c763d; }
.notificacion.success.marca-abajo { border-bottom-color: #3c763d; }

.notificacion.error.marca-izquierda { border-left-color: #a94442; }
.notificacion.error.marca-derecha { border-right-color: #a94442; }
.notificacion.error.marca-arriba { border-top-color: #a94442; }
.notificacion.error.marca-abajo { border-bottom-color: #a94442; }

.notificacion.info.marca-izquierda { border-left-color: #31708f; }
.notificacion.info.marca-derecha { border-right-color: #31708f; }
.notificacion.info.marca-arriba { border-top-color: #31708f; }
.notificacion.info.marca-abajo { border-bottom-color: #31708f; }

.notificacion.warning.marca-izquierda { border-left-color: #ff9800; }
.notificacion.warning.marca-derecha { border-right-color: #ff9800; }
.notificacion.warning.marca-arriba { border-top-color: #ff9800; }
.notificacion.warning.marca-abajo { border-bottom-color: #ff9800; }

/* Transiciones */
.fade-top-enter-active, .fade-top-leave-active,
.fade-bottom-enter-active, .fade-bottom-leave-active,
.fade-enter-active, .fade-leave-active {
  transition: all 1.2s ease;
}

.fade-top-enter, .fade-top-leave-to {
  opacity: 0;
  transform: translateY(-20px) scale(0.95);
}
.fade-bottom-enter, .fade-bottom-leave-to {
  opacity: 0;
  transform: translateY(20px) scale(0.95);
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>
